module.exports = __webpack_public_path__ + "img/26.b7cf1a05.png";